export class Alert {
    msg: string;
    msgType: string;
    isHTML: boolean

    constructor() {
        this.msg = '';
        this.msgType = '';
    }

    success(msg: string) {
        this.msg = msg;
        this.msgType = 'success';
        this.isHTML = false;
    }

    successHtml(html: string) {
        this.msg = html;
        this.msgType = 'success';
        this.isHTML = true;
    }

    info(msg: string) {
        this.msg = msg;
        this.msgType = 'info';
        this.isHTML = false;
    }

    infoHtml(html: string) {
        this.msg = html;
        this.msgType = 'info';
        this.isHTML = true;
    }

    error(msg: string) {
        this.msg = msg;
        this.msgType = 'error';
        this.isHTML = false;
    }

    warning(msg: string) {
        this.msg = msg;
        this.msgType = 'warning';
        this.isHTML = false;
    }

    warningHtml(msg: string) {
        this.msg = msg;
        this.msgType = 'warning';
        this.isHTML = true;
    }

    toString() {
        return this.msg;
    }

    errorHtml(html: string) {
        this.msg = html;
        this.msgType = 'error';
        this.isHTML = true;
    }

    successHTML(html: string) {
        this.msg = html;
        this.msgType = 'success';
        this.isHTML = true;
    }

    close() {
        this.msg = '';
    }
}
